export default class MixpanelPlaceholder {
	identify(id) {
	}

	alias(id) {
	}

	track(name, props) {
	}

	register(values) {
	}

	get people() {
		return {
			set: () => null,
			set_once: () => null,
			increment: () => null,
		};
	}
}
